<div class="mat-dialog-title">
  <p>Gerenciar Cargos</p>
</div>

<div class="mat-dialog-content">
  <div *ngIf="showInitHeader()" class="init-container">
    <a (click)="onAddingJobDescription()">Clique aqui para adicionar um cargo.</a>
  </div>

  <div *ngIf="showAddHader()" class="add-container" fxFlex>
    <mat-form-field fxFlex="70">
      <input matInput type="text" placeholder="Adicionar um novo cargo" [(ngModel)]="jobDescriptionTitle" required />
    </mat-form-field>

    <button mat-flat-button class="add-btn" (click)="createJobDescription()" fxFlex="30">ADICIONAR</button>
  </div>

  <div *ngIf="showEditHader()" class="edit-container" fxFlex>
    <mat-form-field fxFlex="50">
      <input matInput type="text" placeholder="Editar cargo" [(ngModel)]="jobDescriptionTitle" />
    </mat-form-field>

    <mat-checkbox [(ngModel)]="jobDescriptionEnabled" fxFlex="10">Ativo</mat-checkbox>

    <div fxFlex="40" fxLayoutGap="10">
      <button mat-flat-button (click)="onCancelEditingJobDescription()" class="cancel-btn" fxFlex>CANCELAR</button>

      <button mat-flat-button class="save-btn" (click)="editJobDescription()" fxFlex>SALVAR</button>
    </div>
  </div>

  <div class="table-container">
    <div class="tb th-container">
      <span class="t-header">Cargo</span>
      <span class="t-header">Status</span>
      <span class="t-header">Editar</span>
      <span class="t-header">Excluir</span>
    </div>

    <div *ngFor="let jobDescription of jobDescriptionList" class="tb tb-container">
      <!-- COLUMN 1 -->
      <mat-radio-button *ngIf="isBeneficiaryStrategy()" class="t-body" (change)="onSelectJobDescription(jobDescription)" [value]="false">{{
        jobDescription.getTitle()
      }}</mat-radio-button>

      <span *ngIf="!isBeneficiaryStrategy()" class="t-body">{{ jobDescription.getTitle() }}</span>

      <!-- COLUMN 2 -->
      <div *ngIf="jobDescription.getEnabled()" class="flag enabled-job-flag">
        <img src="./assets/icons/check-thin-icon.svg" />
        ATIVO
      </div>
      <div *ngIf="!jobDescription.getEnabled()" class="flag disabled-job-flag">
        <img src="./assets/icons/delete-icon.svg" />
        INATIVO
      </div>

      <!-- COLUMN 3 -->
      <div *ngIf="jobDescription.getIsGeneric()" class="edit-icon-container">
        <img src="./assets/icons/cant-edit-icon.svg" />
      </div>
      <div
        *ngIf="!jobDescription.getIsGeneric()"
        (click)="onEditingJobDescription(jobDescription)"
        class="edit-icon-container hover-effect"
        style="cursor: pointer">
        <img src="./assets/icons/can-edit-icon.svg" />
      </div>

      <!-- COLUMN 4 -->
      <div *ngIf="jobDescription.getIsGeneric()" class="edit-icon-container">
        <img src="./assets/icons/opac-trash-icon.svg" />
      </div>
      <div
        *ngIf="!jobDescription.getIsGeneric()"
        (click)="onDeleteJobDescription(jobDescription)"
        class="edit-icon-container hover-effect"
        style="cursor: pointer">
        <img src="./assets/icons/trash-icon.svg" />
      </div>
    </div>
  </div>
</div>

<div class="mat-dialog-actions">
  <button mat-flat-button class="cancel-btn" (click)="closeDialog()">FECHAR</button>
</div>
